import { Action, createReducer, on } from '@ngrx/store';
import { setDropdownValue } from './dropdown.actions';
import { DropdownState } from './dropdown.state';

export const initialState: DropdownState = {
  selectedValue: null,
};

const _dropdownReducer = createReducer(
  initialState,
  on(setDropdownValue, (state, { value }) => ({ ...state, selectedValue: value }))
);

export function dropdownReducer(state: DropdownState | undefined, action: Action<string>) {
  return _dropdownReducer(state, action);
}
